import { gql } from '@apollo/client';

export const GET_ELEMENTS_DATA = gql`
  query {
    elements(args: { active_only: false }) {
      id
      name
      active
      description
      displays(args: { active_only: false }) {
        id
        name
        active
      }
    }
  }
`;
